"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMouse = exports.getFilledInPixels = exports.drawImage = exports.distanceBetween = exports.angleBetween = void 0;
var drawImage = exports.drawImage = function drawImage(canvas, image, width, height) {
  var ctx = canvas.getContext('2d');
  if (!ctx) return;
  ctx.drawImage(image, 0, 0, width, height);
};
var getMouse = exports.getMouse = function getMouse(event, canvas) {
  if (event == null || canvas == null) return {
    x: 0,
    y: 0
  };
  var result = {
    x: 0,
    y: 0
  };
  var offset = {
    x: 0,
    y: 0
  };
  if (canvas.offsetParent !== undefined) {
    if (canvas.offsetParent instanceof HTMLElement) {
      var currentElement = canvas;
      do {
        offset.x += currentElement.offsetLeft;
        offset.y += currentElement.offsetTop;
        currentElement = currentElement.offsetParent;
      } while (currentElement);
    }
  }
  if (event.type === "touchstart" || event.type === "touchmove" || event.type === "touchend") {
    var touchEvent = event;
    result.x = touchEvent.touches[0].clientX - canvas.getBoundingClientRect().left;
    result.y = touchEvent.touches[0].clientY - canvas.getBoundingClientRect().top;
  }
  if (event.type === "mousedown" || event.type === "mousemove" || event.type === "mouseup") {
    var mouseEvent = event;
    result.x = mouseEvent.clientX - canvas.getBoundingClientRect().left;
    result.y = mouseEvent.clientY - canvas.getBoundingClientRect().top;
  }
  return result;
};

// export const getMouse = (event:any, canvas: HTMLCanvasElement) => {
//   if( event?.type===undefined || event?.type===null )  return { x: 0, y: 0 };

//     const result = { x: 0, y: 0 };
//     const offset = { x: 0, y: 0 };

//     if (canvas.offsetParent !== undefined) {
//       if (canvas.offsetParent instanceof HTMLElement) {
//         do {
//           offset.x += canvas.offsetLeft;
//           offset.y += canvas.offsetTop;
//         } while (((canvas as HTMLElement) = canvas.offsetParent));
//       }
//     }

//     if (event.type==="touchstart" || event.type==="touchmove" || event.type==="touchend") {
//       result.x = event.touches[0].clientX - offset.x;
//       result.y = event.touches[0].clientY - offset.y;
//     } 

//     if(event.type==="mousedown" || event.type==="mousemove" || event.type==="mouseup"){
//       // result.x = event.pageX - offset.x;
//       // result.y = event.pageY - offset.y;

//       result.x = event.clientX - canvas.getBoundingClientRect().left;
//       result.y =  event.clientX - canvas.getBoundingClientRect().top;

//     }

//     return result;
//   };

var distanceBetween = exports.distanceBetween = function distanceBetween(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var angleBetween = exports.angleBetween = function angleBetween(point1, point2) {
  return Math.atan2(point2.x - point1.x, point2.y - point1.y);
};
var getFilledInPixels = exports.getFilledInPixels = function getFilledInPixels(stride, canvas, width, height) {
  if (!stride || stride < 1) stride = 1;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;
  var pixels = ctx.getImageData(0, 0, width, height),
    pdata = pixels.data,
    l = pdata.length,
    total = l / stride,
    count = 0;
  for (var i = count = 0; i < l; i += stride) {
    if (parseInt(String(pdata[i])) === 0) {
      count++;
    }
  }
  return Math.round(count / total * 100);
};